import { CtaTemplateId } from 'src/shared/constants/update';
import { create } from 'zustand';

type ProductUpdateInputModalData = {
  name: string;
  quantity?: number | null;
  supplierCloak?: string | null;
  productQuoteId?: string | null;
  address?: {
    name: string;
    line_1: string;
    line_2?: string;
    city: string;
    state: string;
    zip_code: string;
    country: string;
    contact_name?: string;
    contact_phone?: string;
    contact_email?: string;
    email?: string;
    contactEmail?: string;
  } | null;
};

type ProductUpdateInputModalStore = {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  data?: ProductUpdateInputModalData | null;
  type: CtaTemplateId | null;
  setData: (data: ProductUpdateInputModalData, type: CtaTemplateId) => void;
};

const useProductUpdateInputModal = create<ProductUpdateInputModalStore>()(
  (set) => ({
    isOpen: false,
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
    close: () => set({ isOpen: false }),
    data: null,
    type: null,
    setData: (data: ProductUpdateInputModalData, type: CtaTemplateId) =>
      set({ data, type, isOpen: true })
  })
);

export default useProductUpdateInputModal;
